var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { PrimaryButton } from './components/PrimaryButton';
import { SecondaryButton } from './components/SecondaryButton';
/**
 * be sure to use the `title` prop if the buttons `children` will not be a string
 * @param {'primary' | 'secondary'}variant - button variant (either `primary` or  `secondary`)
 * @param {T}as - the HTML element to be used for the button
 * @returns Button
 */
export const Button = (_a) => {
    var { variant = 'primary', as = 'button' } = _a, props = __rest(_a, ["variant", "as"]);
    const generalProps = Object.assign(Object.assign({}, props), { as, tabIndex: props.disabled ? -1 : 0 });
    return variant === 'secondary' ? (React.createElement(SecondaryButton, Object.assign({}, generalProps))) : (React.createElement(PrimaryButton, Object.assign({}, generalProps)));
};
